import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { signout } from '../../redux/auth/actions';
import { getInvoiceCopyrightIds } from '../../redux/transactions/selectors';
import { generateInvoice } from '../../redux/transactions/actions';

import NavLink from '../nav-link';
import Header from '../header/header';
import { RootState } from '../../redux';
import { CurrentUser } from '../../redux/profiles/interfaces';

export const MainLayout: React.FC<{}> = (props) => {
  const dispatch = useDispatch();

  const currentUser: CurrentUser = useSelector((state: RootState) => state.profiles.currentUser);
  const copyrightIdsSelector = useMemo(getInvoiceCopyrightIds, []);
  const copyrightIds = useSelector((state: RootState) => copyrightIdsSelector(state));

  const isFetching = useSelector((state: RootState) => state.transactions.isFetching);

  const canViewCollections = useMemo(() => {
    const collectionUsers = ["254716466984", "254712064546", "254722841068", "254713862414", "254725004575", "254710938553", "254720898128", "254726830037"];
    if (currentUser) return collectionUsers.includes(currentUser.phoneNumber);
    return false;
  }, [currentUser]);

  const _signout = () => {
    dispatch(signout());
  };

  const isLoggedIn = currentUser !== undefined;

  return (
    <div className="bg-gray-100 main-layout">
      <div className="flex flex-col min-h-full">
        <div className="flex items-center flex-shrink-0 bg-white shadow">
          <Header signout={_signout} isLoggedIn={isLoggedIn} />
        </div>

        <div className="flex flex-col flex-1">
          <div className="flex-0">
            <div className="hidden px-4 py-6 max-width lg:px-20 sm:flex">
              {isLoggedIn && (
                <>
                  <NavLink href="/dashboard">
                    <a className="block w-56 px-4 py-3 text-sm font-medium rounded-full navbar-item sm:py-4">
                      <p className="w-full bg-transparent">Dashboard</p>
                    </a>
                  </NavLink>

                  <NavLink href="/copyrights" subRoutes={['/new-copyright']}>
                    <a className="block w-56 px-4 py-3 ml-4 text-sm font-medium rounded-full navbar-item sm:py-4">
                      <p className="w-full bg-transparent">My Copyrights</p>
                    </a>
                  </NavLink>
                </>
              )}

              <NavLink href="/faq">
                <a className="block w-56 px-4 py-3 ml-4 text-sm font-medium rounded-full navbar-item sm:py-4">
                  <p className="w-full bg-transparent">FAQs</p>
                </a>
              </NavLink>

              <div className="flex-1"></div>

              {canViewCollections && (
                <div className="">
                  <a
                    href="https://collections.libertyafrika.com"
                    target="_blank"
                    className="block w-64 px-4 py-3 ml-4 text-sm font-medium rounded-full navbar-item sm:py-4"
                  >
                    <p className="w-full bg-transparent">
                      Unified Copyright License
                    </p>
                  </a>

                  {/* <a
                    href="https://nrr-collections.libertyafrika.com"
                    target="_blank"
                    className="block w-56 px-4 py-3 ml-4 text-sm font-medium rounded-full navbar-item sm:py-4"
                  >
                    <p className="w-full bg-transparent">Collections</p>
                  </a> */}
                </div>
              )}

              {copyrightIds.length > 0 && (
                <div className="justify-end">
                  <button
                    className="block w-56 px-4 py-3 ml-4 text-sm font-medium rounded-full bg-black-primary navbar-item sm:py-4"
                    onClick={() => dispatch(generateInvoice())}
                    disabled={isFetching}
                  >
                    {isFetching ? (
                      <p>Processing...</p>
                    ) : (
                      <p className="w-full text-justify text-white bg-transparent">
                        Generate Invoice {copyrightIds.length > 0 ? `(${copyrightIds.length})` : ''}
                      </p>
                    )}
                  </button>
                </div>
              )}
            </div>
          </div>

          <div className="flex flex-col flex-1">{props.children}</div>
        </div>

        <div className="flex w-full px-4 py-4 mt-4 border-t border-gray-400 max-width lg:px-20">
          <p className="flex-1">
            For help contact,{' '}
            <span className="font-semibold ">
              <a href="tel: 0791399159" className="text-indigo-500">
                0791399159
              </a>
            </span>{' '}
            or send an email to{' '}
            <span className="font-semibold ">
              <a href="mailto: nrr@copyright.go.ke" className="text-indigo-500">
                nrr@copyright.go.ke
              </a>
            </span>
          </p>
          <p className="flex-0">
            Kenya Copyrights Board,{' '}
            <span className="font-semibold">&#169;{new Date().getFullYear()}</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default MainLayout;
